import confetti from "canvas-confetti";

/**
 * Fires a small, tasteful cyan/indigo confetti burst at the top third of the
 * viewport. Staged as 3 short bursts (0, 200ms, 420ms) to feel alive without
 * looking like a birthday card.
 *
 * Palette intentionally restricted to our brand colours — NO rainbow.
 */
export function celebrateRecord() {
  if (typeof window === "undefined") return;
  const palette = ["#00E5FF", "#4F46E5", "#A5F3FC", "#818CF8", "#22D3EE"];

  const fire = (opts) => {
    try {
      confetti({
        particleCount: 120,
        spread: 70,
        origin: { y: 0.3 },
        colors: palette,
        scalar: 1.0,
        ticks: 200,
        ...opts,
      });
    } catch (e) {
      // Confetti failures are purely cosmetic — never bubble up.
      console.warn("confetti failed", e);
    }
  };

  fire({});
  setTimeout(() => fire({ particleCount: 80, spread: 90, origin: { y: 0.25, x: 0.3 } }), 200);
  setTimeout(() => fire({ particleCount: 80, spread: 90, origin: { y: 0.25, x: 0.7 } }), 420);
}
